import { useEffect, useState } from "react";
import api, { formatApiError } from "@/lib/api";
import BlogCard from "@/components/common/BlogCard";

export default function Blog() {
    const [posts, setPosts] = useState(null);
    const [error, setError] = useState("");

    useEffect(() => {
        api.get("/blog/posts")
            .then((r) => setPosts(r.data))
            .catch((e) => setError(formatApiError(e.response?.data?.detail) || e.message));
    }, []);

    return (
        <div data-testid="blog-page">
            <section className="border-b-4 border-ink py-20 md:py-28">
                <div className="max-w-7xl mx-auto px-6 md:px-10 lg:px-16">
                    <span className="label-mono inline-block bg-brand-yellow border-2 border-ink rounded-full px-3 py-1">
                        Our thoughts
                    </span>
                    <h1 className="mt-5 font-display text-5xl sm:text-6xl lg:text-7xl font-black leading-[0.92] tracking-tighter max-w-4xl">
                        Field notes from{" "}
                        <span className="bg-brand-pink inline-block px-3 -rotate-1 border-2 border-ink shadow-brutal">
                            building &amp; growing
                        </span>{" "}
                        SaaS.
                    </h1>
                    <p className="mt-7 font-body text-ink/70 text-lg max-w-2xl">
                        No SEO sludge. No 12-step ultimate guides. Just opinions
                        and playbooks pulled from real projects.
                    </p>
                </div>
            </section>

            <section className="py-20 md:py-28">
                <div className="max-w-7xl mx-auto px-6 md:px-10 lg:px-16">
                    {error && (
                        <div
                            data-testid="blog-error"
                            className="brutal-card bg-brand-orange text-white p-5 mb-8"
                        >
                            {error}
                        </div>
                    )}
                    {posts === null ? (
                        <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-7">
                            {[0, 1, 2].map((i) => (
                                <div
                                    key={i}
                                    className="brutal-card p-0 overflow-hidden animate-pulse"
                                >
                                    <div className="aspect-[16/10] bg-cream" />
                                    <div className="p-6 space-y-3">
                                        <div className="h-3 w-24 bg-cream" />
                                        <div className="h-6 bg-cream" />
                                        <div className="h-4 w-3/4 bg-cream" />
                                    </div>
                                </div>
                            ))}
                        </div>
                    ) : posts.length === 0 ? (
                        <p
                            data-testid="blog-empty"
                            className="font-body text-ink/60"
                        >
                            No posts yet. Check back soon.
                        </p>
                    ) : (
                        <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-7">
                            {posts.map((p, i) => (
                                <BlogCard key={p.id} post={p} index={i} />
                            ))}
                        </div>
                    )}
                </div>
            </section>
        </div>
    );
}
